import { barChart } from '../charts/barchart';
import { BarchartConfig, BarchartPiece } from '../../source';
import { NotNullProperties } from './helpers';
import { ChartElem } from '../charts';
import { fromNullable, some } from 'fp-ts/lib/Option';
import { getAlias } from '../../app';

const render = (
    props: NotNullProperties,
    row: BarchartConfig,
    metadataId: string,
) => barChart(chartElementsByColumns(row.options.columns, props, metadataId));

const chartElementsByColumns = (
    columns: BarchartPiece[],
    props: NotNullProperties,
    metadataId: string,
) => columns.map(convertColumnToChartElem(props, metadataId));

// TODO pay attention to type of value which is any in props
const convertColumnToChartElem =
    (props: NotNullProperties, metadataId: string) =>
    (column: BarchartPiece): ChartElem => ({
        value: props[column.propName],
        label: getAlias(
            fromNullable(column.label).getOrElse(column.propName),
            some(metadataId),
        ),
        unit: column.unit,
    });

export default render;
